import { jsx as _jsx } from "react/jsx-runtime";
import { getMessage } from '../../messaging/MESSAGE';
import { getXOffset, getYOffset } from './blobUtils';
import { BlobContentWrapper, ForeignObject } from './Blob.styles';
export const BlobVideo = ({
  messageKey,
  children
}) => {
  const {
    imageWidth = '100%',
    blobHeight = '100%',
    isCard
  } = getMessage(messageKey);
  return /*#__PURE__*/_jsx(ForeignObject, {
    height: blobHeight,
    width: imageWidth,
    x: getXOffset(messageKey, isCard),
    y: getYOffset(messageKey, isCard),
    children: /*#__PURE__*/_jsx(BlobContentWrapper, {
      children: children
    })
  });
};